import type { ReactElement } from "react";
import {
  Calendar,
  Cat,
  Clap,
  Discount,
  Document,
  Dog,
  Learn,
  LightningBolt,
  Paw,
  Phone,
  Points,
  Scale,
  ShieldHeart,
  Trophy,
} from "ui-kit/icons";

/**
 * Contentful stores an icon as a free-text option, so the mapping from that
 * string to a glyph lives here rather than in the schema.
 *
 * Deliberately a small explicit table, not the whole icon set: only these
 * fifteen reach the bundle, and an option nobody selected costs nothing.
 *
 * The glyphs carry no size — they stay at 1em so whatever frames them (an
 * `IconFrame`, an `AccordionTitle`) sets the size from CSS.
 */
const icons: Record<string, ReactElement> = {
  Paw: <Paw />,
  Clap: <Clap />,
  Flash: <LightningBolt />,
  Phone: <Phone />,
  Percent: <Discount />,
  Knowledge: <Learn />,
  Star: <Points />,
  Scale: <Scale />,
  Cat: <Cat />,
  Dog: <Dog />,
  Headset: <Phone />,
  Firstaid: <ShieldHeart />,
  Calendar: <Calendar />,
  Trophy: <Trophy />,
  Document: <Document />,
};

export const getIcon = (icon?: string | null): ReactElement =>
  icons[icon as keyof typeof icons] ?? icons.Paw;
